import * as percentNumeral from "numeral";
import { RawNumberFormatter } from "./number_formatter.js";

// TODO: Document it
class PercentFormatter extends RawNumberFormatter {

  format(value, format = "0[.][00]%") {
    if(value === null || value === undefined) {
      return "";
    }
    let stringValue = `${value}`.replace(".", ",");
    let percent = percentNumeral(stringValue);
    return percent.format(format);
  }
}

const instance = new PercentFormatter();
export default instance;